import { render, staticRenderFns } from "./ContactStatistics.vue?vue&type=template&id=3310af8f&scoped=true&"
import script from "./ContactStatistics.vue?vue&type=script&lang=js&"
export * from "./ContactStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ContactStatistics.vue?vue&type=style&index=0&id=3310af8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3310af8f",
  null
  
)

export default component.exports